import { Input } from 'antd';
import * as React from 'react';
// @ts-ignore
import ReactModal from 'react-modal';
// @ts-ignore
import Slider from 'rc-slider';
import {ChangeEvent} from "react";

const MAX_FEET = 5280;

export interface IProps {
    onClose: any;
    show: boolean;
    cancel: any;
    complete: any;
}

export interface IState {
    value: number | null;
    units: string;
}

export class BufferModal extends React.PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: null,
            units: 'feet',
        };
    }
    onSliderChange = (value: number) => {
        this.setState({
            value,
        });
    };

    onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            value: Math.max(Math.min(Number(event.target.value), MAX_FEET), 0)
        })
    }

    render() {
        return (
            <ReactModal
                /*
                  Boolean describing if the modal should be shown or not.
                */
                isOpen={this.props.show}
                ariaHideApp={false}
                onRequestClose={this.props.cancel}
                style={{
                    overlay: {
                        zIndex: 1000
                    },
                    content: {
                        maxWidth: '500px',
                        maxHeight: '200px',
                        margin: 'auto'
                    }
                }}
            >
                <div style={{marginBottom: '10px'}}>Buffer Feature</div>
                <div  style={{marginBottom: '30px'}}>
                    <Slider
                        min={0} max={MAX_FEET} defaultValue={0} marks={{ 0: 0, [MAX_FEET]: MAX_FEET}} step={1}
                        tipFormatter={(value: number) => `${value} feet`}
                        value={this.state.value}
                        onChange={this.onSliderChange}
                    />
                </div>
                <div>
                    <Input size="small"
                        value={this.state.value || 0}
                        addonAfter={this.state.units}
                        onChange={this.onInputChange}
                    />
                </div>
                <div>5280 feet = 1 mile</div>
                <div className="buttonRow">
                    <div onClick={this.props.cancel}>
                        <button className="styledButton" style={{backgroundColor: '#f15a5a'}}>Cancel</button>
                    </div>
                    <div onClick={() => this.props.complete(this.state.value, this.state.units)}>
                        <button className="styledButton" style={{backgroundColor: '#646bf1'}}>Buffer</button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}
